// extracted by mini-css-extract-plugin
module.exports = {"rightRailWithSplitRow":"styles_rightRailWithSplitRow__2zA_W","main":"styles_main__1YkdF","splitCol":"styles_splitCol__3pOrZ"};